import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd  } from '@angular/router';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.css']
})
export class LeftMenuComponent implements OnInit {

  currentRoute = '';
  
  constructor(private router: Router, private apiSvc: ApiService) {
	this.router.events.subscribe((event:any) => {
		if (event instanceof NavigationEnd) {
		  this.currentRoute = this.router.url;
		}
	});
  }

  ngOnInit(): void {
	
  }
  
  /**
   * logout function
   * remove session stored in local browser
   */
  logout() {
	
  }
  
  /**
   * navigate to which page
   */
  navigatePage(page){
	this.apiSvc.navigateInternal(page);
  }

}
